import React from "react";
import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
import greenhouseWhite from "./greenhouse-white.png";
import leverPng from "./favicon-lever-48x48.png";
import leverPngGreen from "./favicon-lever-48x481.png";
import greenhouse from "./greenhouse-success.png";
import smartrecruterIcon from "./smart-recruiter-success.png";
import smartrecruterWhiteIcon from "./smart-recruiter-white.png";
import hubspotWhiteIcon from "./hubspot.png";

import hubspotOrangeIcon from "./hubspot-orange.png";
import hubspotGrayIcon from "./hubspot-gray.png";
import DoximityGrayIcon from "./logo-og-doximity.png";

//--------------- Image Imports-------------
import whitearrowicon from "../images/whitearrow.svg";
import starsicon from "../images/stars.svg";

type CustomIconComponentProps = GetProps<typeof Icon>;

const UploadSvg = () => (
  <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dii_12181_8073)">
      <path
        d="M2.5 9C2.5 4.58172 6.08172 1 10.5 1H34.5C38.9183 1 42.5 4.58172 42.5 9V33C42.5 37.4183 38.9183 41 34.5 41H10.5C6.08172 41 2.5 37.4183 2.5 33V9Z"
        fill="white"
      />
      <path
        d="M3 9C3 4.85786 6.35786 1.5 10.5 1.5H34.5C38.6421 1.5 42 4.85786 42 9V33C42 37.1421 38.6421 40.5 34.5 40.5H10.5C6.35786 40.5 3 37.1421 3 33V9Z"
        stroke="#E4E7EC"
      />
      <path
        d="M19.166 24.3333L22.4993 21M22.4993 21L25.8327 24.3333M22.4993 21V28.5M29.166 24.9524C30.1839 24.1117 30.8327 22.8399 30.8327 21.4167C30.8327 18.8854 28.7807 16.8333 26.2493 16.8333C26.0673 16.8333 25.8969 16.7383 25.8044 16.5814C24.7177 14.7374 22.7114 13.5 20.416 13.5C16.9642 13.5 14.166 16.2982 14.166 19.75C14.166 21.4718 14.8622 23.0309 15.9885 24.1613"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_dii_12181_8073"
        x="0.5"
        y="0"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12181_8073" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12181_8073"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_12181_8073" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect3_innerShadow_12181_8073"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_12181_8073"
          result="effect3_innerShadow_12181_8073"
        />
      </filter>
    </defs>
  </svg>
);

const DollerSvg = () => (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.13636 15.4545V0.90909H5.06818V15.4545H4.13636ZM7.27273 
      5.27273C7.20455 4.69697 6.92803 4.25 6.44318 3.93182C5.95833 
      3.61364 5.36364 3.45455 4.65909 3.45455C4.14394 3.45455 3.69318 
      3.53788 3.30682 3.70455C2.92424 3.87121 2.625 4.10038 2.40909 
      4.39205C2.19697 4.68371 2.09091 5.01515 2.09091 5.38636C2.09091 
      5.69697 2.16477 5.96401 2.3125 6.1875C2.46402 6.4072 2.6572 6.59091 
      2.89205 6.73864C3.12689 6.88258 3.37311 7.00189 3.63068 7.09659C3.88826 
      7.1875 4.125 7.26136 4.34091 7.31818L5.52273 7.63636C5.82576 7.71591 
      6.16288 7.82576 6.53409 7.96591C6.90909 8.10606 7.26705 8.29735 7.60795 
      8.53977C7.95265 8.77841 8.23674 9.08523 8.46023 9.46023C8.68371 9.83523 
      8.79545 10.2955 8.79545 10.8409C8.79545 11.4697 8.63068 12.0379 8.30114 
      12.5455C7.97538 13.053 7.49811 13.4564 6.86932 13.7557C6.24432 14.0549 
      5.48485 14.2045 4.59091 14.2045C3.75758 14.2045 3.03598 14.0701 2.42614 
      13.8011C1.82008 13.5322 1.3428 13.1572 0.994318 12.6761C0.649621 12.1951 
      0.454545 11.6364 0.409091 11H1.86364C1.90152 11.4394 2.04924 11.803 2.30682 
      12.0909C2.56818 12.375 2.89773 12.5871 3.29545 12.7273C3.69697 12.8636 4.12879 
      12.9318 4.59091 12.9318C5.12879 12.9318 5.61174 12.8447 6.03977 12.6705C6.4678 
      12.4924 6.80682 12.2462 7.05682 11.9318C7.30682 11.6136 7.43182 11.2424 7.43182 
      10.8182C7.43182 10.4318 7.32386 10.1174 7.10795 9.875C6.89205 9.63258 6.60795 9.43561 
      6.25568 9.28409C5.90341 9.13258 5.52273 9 5.11364 8.88636L3.68182 8.47727C2.77273 
      8.21591 2.05303 7.8428 1.52273 7.35795C0.992424 6.87311 0.727273 6.23864 0.727273 
      5.45455C0.727273 4.80303 0.903409 4.23485 1.25568 3.75C1.61174 3.26136 2.08902 
      2.88258 2.6875 2.61364C3.28977 2.34091 3.96212 2.20455 4.70455 2.20455C5.45455 
      2.20455 6.12121 2.33901 6.70455 2.60795C7.28788 2.87311 7.75 3.23674 8.09091 
      3.69886C8.43561 4.16098 8.61742 4.68561 8.63636 5.27273H7.27273Z"
      fill="#344054"
    />
  </svg>
);

export const UploadIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UploadSvg} {...props} />
);
export const DollerIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DollerSvg} {...props} />
);

export const ImageImports = {
  whitearrowicon,
  starsicon,
};

export const SmartRecruiterSVG = () => (
  <img src={smartrecruterIcon} alt="" style={{ height: "18px", width: "18px", objectFit: "contain" }} />
);

export const SmartRecruiterWhiteSVG = () => (
  <img src={smartrecruterWhiteIcon} alt="" style={{ height: "18px", width: "18px", objectFit: "contain" }} />
);

export const HubspotWhiteSVG = () => (
  <img src={hubspotWhiteIcon} alt="" style={{ height: "18px", width: "18px", objectFit: "contain" }} />
);

export const GreenhouseSVG = () => (
  <img
    src={greenhouse}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);
export const GreenhouseSVGWhite = () => (
  <img
    src={greenhouseWhite}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);
export const LeverIcon = () => (
  <img
    src={leverPng}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);

export const LeverIconGreen = () => (
  <img
    src={leverPngGreen}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);

export const HubspotIconOrange = () => (
  <img
    src={hubspotOrangeIcon}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);

export const HubspotIconGray = () => (
  <img
    src={hubspotGrayIcon}
    alt=""
    style={{ height: "18px", width: "18px", objectFit: "contain" }}
  />
);
export const DoximityIconGray = () => (
  <img
    src={DoximityGrayIcon}
    alt=""
    style={{ height: "22px", width: "22px", objectFit: "contain" }}
  />
);


export const SmartRecruiterIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={SmartRecruiterSVG} {...props} />;

export const SmartRecruiterWhiteIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={SmartRecruiterWhiteSVG} {...props} />;

export const HubspotWhiteIcon = (
  props: Partial<CustomIconComponentProps>
) => <Icon component={HubspotWhiteSVG} {...props} />;

export const GreenhouseIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GreenhouseSVG} {...props} />
);

export const GreenhouseWhiteIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={GreenhouseSVGWhite} {...props} />
);
export const LeverIconCompo = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LeverIcon} {...props} />
);

export const LeverIconCompoGreen = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={LeverIconGreen} {...props} />
);

export const HubspotIconCompoOrange = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HubspotIconOrange} {...props} />
);

export const HubspotIconCompoGray = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HubspotIconGray} {...props} />
);
export const DoximityIconCompoGray = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DoximityIconGray} {...props} />
);